import { api } from '~/trpc-extra/api';
import { notifications } from '@mantine/notifications';
import { modals } from '@mantine/modals';
import { useRouter } from 'next/router';
import { queryParamToString } from '~/logic/query-param';
import { useCallback } from 'react';

export function useSetAsTrunk() {
  const trpcUtils = api.useUtils();
  const router = useRouter();
  const projectId = queryParamToString(router.query.projectId);
  const testId = queryParamToString(router.query.testId);

  const { mutate: setAsTrunk } = api.test.setAsTrunk.useMutation({
    onSuccess: async () => {
      notifications.show({
        title: 'Success',
        message: 'Updated version to current version',
        color: 'teal',
      });
      await Promise.allSettled([trpcUtils.test.getTest.invalidate(), trpcUtils.test.getMeta.invalidate()]);
      void router.push(`/project/${projectId}/test/${testId}`);
    },
    onError: () => {
      notifications.show({
        title: 'Error',
        message: 'Failed to revert past version to current version',
        color: 'red',
      });
    },
  });

  const setAsTrunkDialog = useCallback(
    ({ testContentId }: { testContentId: string }) => {
      modals.openConfirmModal({
        title: 'Revert to this version',
        children: <div>Are you sure you want to revert to this version?</div>,
        labels: {
          confirm: 'Revert',
          cancel: 'Cancel',
        },
        centered: true,
        onConfirm: () => {
          setAsTrunk({ testContentId });
        },
        onCancel: () => {
          modals.closeAll();
        },
      });
    },
    [setAsTrunk],
  );

  return setAsTrunkDialog;
}
